import SessionManager from "@/utils/SessionManager";
import EventBus from "@/utils/EventBus";
import Events from "@/utils/Events";
import Log from "@/utils/Log";
import Perms from "@/server/Perms";

class PermissionsSet {
    constructor(){
        this.detached = false;
        this.ALL_BUSINESS_ENTITIES_AUDIT = SessionManager.hasPermission(Perms.ALL_BUSINESS_ENTITIES_AUDIT);
        this.ALL_BUSINESS_ENTITIES_READ = SessionManager.hasPermission(Perms.ALL_BUSINESS_ENTITIES_READ);
        this.ALL_BUSINESS_ENTITIES_WRITE = SessionManager.hasPermission(Perms.ALL_BUSINESS_ENTITIES_WRITE);
        this.ALL_DASHLETS = SessionManager.hasPermission(Perms.ALL_DASHLETS);
        this.ALL_REPORT = SessionManager.hasPermission(Perms.ALL_REPORT);
        this.APPLICATION_ARCHITECT = SessionManager.hasPermission(Perms.APPLICATION_ARCHITECT);
        this.ASSIGN_PRODUCTS_TO_SEASON = SessionManager.hasPermission(Perms.ASSIGN_PRODUCTS_TO_SEASON);
        this.BOOKING_NOTIFICATION = SessionManager.hasPermission(Perms.BOOKING_NOTIFICATION);
        this.BRANDING_PARAMETERS = SessionManager.hasPermission(Perms.BRANDING_PARAMETERS);
        this.BROADCAST_NOTIFICATIONS = SessionManager.hasPermission(Perms.BROADCAST_NOTIFICATIONS);
        this.DATA_IMPORT = SessionManager.hasPermission(Perms.DATA_IMPORT);
        this.EXTRA_LOGISTIC_BOOKING = SessionManager.hasPermission(Perms.EXTRA_LOGISTIC_BOOKING);
        this.IHUB_TRIGGER = SessionManager.hasPermission(Perms.IHUB_TRIGGER);
        this.IHUB_USER = SessionManager.hasPermission(Perms.IHUB_USER);
        this.ORGANIZATION_SETTINGS = SessionManager.hasPermission(Perms.ORGANIZATION_SETTINGS);
        this.PP_SAMPLE_DELETE = SessionManager.hasPermission(Perms.PP_SAMPLE_DELETE);
        this.PRODUCT_ADMIN = SessionManager.hasPermission(Perms.PRODUCT_ADMIN);
        this.SUPERUSER = SessionManager.hasPermission(Perms.SUPERUSER);
        this.WRITE_ACCESS_TO_FIELD_UNIT = SessionManager.hasPermission(Perms.WRITE_ACCESS_TO_FIELD_UNIT);

        for(const k in Perms){
            const perm = Perms[k];
            if(perm?.type === 'dynamic'){
                this[perm.name] = SessionManager.hasPermission(perm.name);
            }
        }
        this.handler =  () => this.refreshPermissions();
        EventBus.$on(Events.permissionsChanged, this.handler);
    }

    refreshPermissions(){
        Log.trace("PermissionsSet refreshed");
        this.ALL_BUSINESS_ENTITIES_AUDIT = SessionManager.hasPermission(Perms.ALL_BUSINESS_ENTITIES_AUDIT);
        this.ALL_BUSINESS_ENTITIES_READ = SessionManager.hasPermission(Perms.ALL_BUSINESS_ENTITIES_READ);
        this.ALL_BUSINESS_ENTITIES_WRITE = SessionManager.hasPermission(Perms.ALL_BUSINESS_ENTITIES_WRITE);
        this.ALL_DASHLETS = SessionManager.hasPermission(Perms.ALL_DASHLETS);
        this.ALL_REPORT = SessionManager.hasPermission(Perms.ALL_REPORT);
        this.APPLICATION_ARCHITECT = SessionManager.hasPermission(Perms.APPLICATION_ARCHITECT);
        this.ASSIGN_PRODUCTS_TO_SEASON = SessionManager.hasPermission(Perms.ASSIGN_PRODUCTS_TO_SEASON);
        this.BOOKING_NOTIFICATION = SessionManager.hasPermission(Perms.BOOKING_NOTIFICATION);
        this.BRANDING_PARAMETERS = SessionManager.hasPermission(Perms.BRANDING_PARAMETERS);
        this.BROADCAST_NOTIFICATIONS = SessionManager.hasPermission(Perms.BROADCAST_NOTIFICATIONS);
        this.DATA_IMPORT = SessionManager.hasPermission(Perms.DATA_IMPORT);
        this.EXTRA_LOGISTIC_BOOKING = SessionManager.hasPermission(Perms.EXTRA_LOGISTIC_BOOKING);
        this.IHUB_TRIGGER = SessionManager.hasPermission(Perms.IHUB_TRIGGER);
        this.IHUB_USER = SessionManager.hasPermission(Perms.IHUB_USER);
        this.ORGANIZATION_SETTINGS = SessionManager.hasPermission(Perms.ORGANIZATION_SETTINGS);
        this.PP_SAMPLE_DELETE = SessionManager.hasPermission(Perms.PP_SAMPLE_DELETE);
        this.PRODUCT_ADMIN = SessionManager.hasPermission(Perms.PRODUCT_ADMIN);
        this.SUPERUSER = SessionManager.hasPermission(Perms.SUPERUSER);
        this.WRITE_ACCESS_TO_FIELD_UNIT = SessionManager.hasPermission(Perms.WRITE_ACCESS_TO_FIELD_UNIT);

        for(const k in Perms){
            const perm = Perms[k];
            if(perm?.type === 'dynamic'){
                this[perm.name] = SessionManager.hasPermission(perm.name);
            }
        }
    }

    detach(){
        if(!this.detached) {
            EventBus.$off(Events.permissionsChanged, this.handler);
            Log.trace("PermissionsSet detached");
            this.detached = true;
        }
    }

}

export default PermissionsSet;
